import type { ReactNode } from 'react'
import { cx } from '../utils/cx'

export function ProofToolbar({ children, className }: { children?: ReactNode; className?: string }) {
  return (
    <div className={cx('st-proof-toolbar', className)}>
      <div className="st-proof-toolbar-inner">{children}</div>
    </div>
  )
}
